<template>
  <div class="timetable">
    <div class="content-wrapper">
      <calendar @changeDay="getDay" @changeToday="changeToday"></calendar>
      <div class="list-wrapper">
        <!--<div class="list-title">-->
          <!--{{computeChoseDay}}-->
        <!--</div>-->
        <div class="list-item" v-for="(item,index) in list" v-if="list.length">
          <div class="item-top">
            <div class="time-wrapper">
              <p class="starttime">{{item.planstarttime.substring(11,16)}}</p>
              <p class="endtime">{{item.planendtime.substring(11,16)}}</p>
            </div>
            <div class="item-img-wrapper">
              <span class="item-img-icon" v-if="item.democlass==='0'">正式课</span>
              <img :src="imgprefix+item.lessonfaceimg" alt="课程图片" width="142" height="92">
            </div>
            <div class="class-content-wrapper">
              <p class="main-title">
                {{decodeURIComponent(item.lessonname)}}
                <span class="connect" @click="QueryClassUser(item)">学员名单</span>
              </p>
              <p class="sub-title">
                [{{decodeURIComponent(item.classmodename)}}]
                {{decodeURIComponent(item.classname)}}</p>
            </div>
            <span v-if="item.statusflag==='1'" class="finish-icon"></span>
          </div>
          <div class="item-bottom">
            <div class="mulu-item">
              <div class="time-wrapper">
                <span class="mulu-name">{{decodeURIComponent(item.catalogname)}}</span>
              </div>
              <div class="mulu-operate-wrapper">
                <button class="mulu-btn check" :class="{'show':item.show,'not-show':!item.show}"
                        @click="getCourseWare(item)">查看课件
                </button>
                <button class="mulu-btn add" @click="showAddWare(item)">添加课件</button>
                <button class="mulu-btn review"
                        v-if="item.statusflag==='1'&&item.txtfilename!==''&&item.mp3filename!==''"
                        @click="reviewLive(item)">课程回看
                </button>
                <button class="mulu-btn live" @click="gotoLive(item)"
                        v-if="item.statusflag!='1'||isSameDay(returnServerToday,item.planstarttime.substring(0,10))">进入上课
                </button>

              </div>
            </div>
            <div class="wareList-wrapper" v-if="item.show">
              <template v-if="!isEmpty(item.coursewarelist)">
                <div class="ware-item" v-for="(data,index2) in item.coursewarelist">
                  <div class="ware-img-wrapper">
                    <img :src="imgprefix+data.faceimg" alt="课件封面" width="60" height="40">
                  </div>
                  <p class="courseware-name">{{decodeURIComponent(data.coursewarename)}}</p>
                  <section class="courseware-btn-wrapper">
                    <button class="courseware-btn transparent" @click="previewWare(data)">预览</button>
                    <button class="courseware-btn transparent" @click="editWare(data)">编辑</button>
                    <button class="courseware-btn del" @click="delWare(data, index, index2)">删除</button>
                  </section>
                </div>
              </template>
              <p v-else style="text-align:center;font-size: 16px;color:#666;font-weight:bold">暂无课件</p>
            </div>
          </div>
        </div>
        <div class="no-result" v-if="isEmpty(list)">
          <img src="./noresult.png" alt="没有结果" width="290" height="164">
          <p class="noresult-link">~暂无待上的课程~</p>
        </div>
      </div>
    </div>
    <div class="enrollpop-wrapper" v-if="enrollShow">
      <div class="enrollpop">
        <h2 class="title">报名列表</h2>
        <h3 class="sub-title">共{{enrollTotal}}人报名</h3>
        <img class='close'
             @click="enrollShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <table class="table">
          <tr class="tr-title">
            <th class="th">上课日期</th>
            <th class="th">学员</th>
            <th class="th">电话</th>
            <th class="th">报名时间</th>
          </tr>
          <template v-for="item in enrollList">
            <tr class="tr-content">
              <td class="td">{{item.startdate.substring(0, 11)}}</td>
              <td class="td">{{decodeURIComponent(item.username)}}</td>
              <td class="td">{{decodeURIComponent(item.phone)}}</td>
              <td class="td">{{decodeURIComponent(item.addtime).substring(0, 16)}}</td>
            </tr>
          </template>

        </table>
      </div>
    </div>
    <!--添加课件-->
    <div class="newpop-mask" v-if="newShow">
      <div class="newpop">
        <h2 class="new-title">添加课件</h2>
        <img class='close'
             @click="newShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <div class="block btn1" @click="showExistedWare">
          <img class='img' src="./btn1.png" alt="add" width="30" height="30">
          <span class="text">选择已有课件</span>
        </div>
        <div class="block btn2">
          <img class='img' src="./btn2.png" alt="add" width="30" height="30">
          <span class="text">选择文件上传</span>
          <input class="input-file"
                 type="file"
                 accept=".pdf,.ppt,.pptx,.doc,.docx"
                 @change="upFile">
        </div>
        <p class="newpop-hint">*课件上传之后如果显示格式不对，请把文件另存为pptx或者pdf格式后重新上传</p>
      </div>
    </div>
    <div class="warePop" v-if="warePopShow">
      <div class="ware-content-wrapper">
        <h3 class="ware-title">选择课件</h3>
        <div class="flex-wrapper">
          <p class="left">已选择：{{count}}个</p>
        </div>
        <div class="ware-wrapper">
          <template v-for="(item,index) in lessonWareList">
            <div class="classware">
              <img class="cover" :src="computeUrl(item.faceimg)" alt="cover" width="80" height="60">
              <div class="classware-middle">
                <h3 class="title">{{decodeURIComponent(item.coursewarename)}}</h3>
                <p class="introduce">{{decodeURIComponent(item.introduce)}}</p>
              </div>
              <img v-if="item.show===false"
                   @click="show(item,index)"
                   class="del"
                   src="./beforeSelect.png"
                   alt="delete-button" width="20"
                   height="20">
              <img v-if="item.show===true"
                   @click="item.show=false;count--"
                   class="del"
                   src="./selected.png"
                   alt="delete-button" width="20"
                   height="20">
            </div>
          </template>
        </div>
        <div class="ware-btn-outside">
          <div class="ware-btn-inside">
            <button class="cancel" @click="warePopShow=false;">取消</button>
            <button class="confirm" @click="addWare">确认</button>
          </div>
        </div>
      </div>
    </div>
    <div class="chantime-mask" v-if="changetimeShow">
      <div class="chantime">
        <p class="img-wrapper">
          <img class='close'
               @click="newShow=false;"
               src="./changetime-hint.png"
               alt="close"
               width="128"
               height="128">
        </p>
        <h2 class="chantime-title">全优在线提示！</h2>
        <p class="changetime-para">只有今天有课程才能进入直播间，如果无法进入，可以修改上课时间到今天</p>
        <button class="changetime-btn confirm" @click="goChangeTime">修改时间上课</button>
        <button class="changetime-btn cancel" @click="changetimeShow=false">暂不修改</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import calendar from './calendar/calendar'
  import {isSameDay} from 'common/js/calendar.js'
  import Vue from 'vue';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        //-----------以下内容和课程表有关-----------//
        list: [],         //课程表列表
        currentPage: 1,
        totoalPage: 0,
        time: new Date(),
        returnServerToday: null,     //服务端返回的今天日期
        //--------报名列表----------//
        enrollShow: false,
        enrollTotal: 0,
        enrollList: [],
        //添加课件
        newShow: false,
        //--------添加PDF----------//
        fileName: '',
        loading: null,
        //--------选择已有课件----------//
        warePopShow: false,
        count: 0,
        lessonWareList: [],
        classScheduleNow: null,
        //--------修改时间提示----------//
        changetimeShow: false,
      }
    },
    methods: {
      isSameDay(one, two) {
        return isSameDay(one, two);
      },
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      computeUrl(url) {
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      getDay(e) {
        this.time = e;
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      changeToday() {
        this.time = new Date();
        let params = this.conputeXHRParams(1);
        this.loadList(params);
        this.$forceUpdate();
      },
      computeDayTime(date) {
        let month = "0" + (date.getMonth() + 1);
        let day = "0" + date.getDate();
        return date.getFullYear() + '-' + month.substring(month.length - 2) + '-' + day.substring(day.length - 2);
      },
      //根据用户选择的选项，计算XHR请求的参数(请求当前的课程)
      conputeXHRParams(pageNumber) {
        //根据当前时间获得"XXXX-XX-XX"的事件格式
        let date = this.computeDayTime(this.time);
        let params = {
          c: 'ClassSchedule',
          a: 'QueryOnedayClassSchedule',
          id: this.id,                //sessionid
          rid: this.schoolNow.rid,
          isstudent: 0,
          date: date,
          pageno: pageNumber,
        };
        //对应后台，1是试听课，0是收费课
        if (this.index == '1') {
          params.democlass = 1;
        } else if (this.index == '0') {
          params.democlass = 0;
        }
        return params;
      },
      loadList(params) {
        this.list = [];
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: params
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            if (!this.returnServerToday) {
              this.returnServerToday = response.date;
            }
            let list = response.list;
            for (let i = 0; i < list.length; i++) {
              list[i].show = false;
              list[i].coursewarelist = null;
            }
            this.list = list;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //-------------------学生列表---------------------------//
      QueryClassUser(item) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassUser',
            a: 'QueryClassUser',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            pageno: 1,
            pagesize: 100,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.enrollShow = true;
            this.enrollList = response.list;
            this.enrollTotal = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {

        });
      },
      //-------------------获取课件---------------------------//
      getCourseWare(item) {
        if (item.show === false) {
          this.$http({
            url: '/indexapp.php',
            method: 'GET',
            params: {
              c: 'ClassCourseWare',
              a: 'QueryClassCourseWare',
              id: this.id,
              classcatalogid: item.catalogid,
              pageno: 1,
              pagesize: 200,
            }
          }).then((response) => {
            response = response.data;
            if (response.code === 111) {
              this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
            }
            if (response.code === 200) {
              item.coursewarelist = response.list;
              this.$forceUpdate();
            }
          }).catch((err) => {

          });
        }
        item.show = !item.show;
      },
      //显示添加课件
      showAddWare(ele) {
        this.newShow = true;
        this.classScheduleNow = ele;
      },
      showExistedWare() {
        this.lessonWareList = [];
        this.newShow = false;
        this.warePopShow = true;
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: this.classScheduleNow.rid,
            lessonid: this.classScheduleNow.lessonid,
            pageno: 1,
            pagesize: 300,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          this.lessonWareList = response.list;
          if (this.lessonWareList != null) {
            this.lessonWareList.forEach(function (ele) {
              ele.show = false;
            })
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      upFile(e) {
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        this.fileName = file.name;
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
        this.newShow = false;
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        // console.log(response)
        let jsonobj = JSON.parse(response);
        // console.log('---------------')
        // console.log(jsonobj)

        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'ImportCourseWareFromImages',
            id: this.id,
            rid: this.classScheduleNow.rid,
            lessonid: this.classScheduleNow.lessonid,
            classid: this.classScheduleNow.classid,
            classcatalogid: this.classScheduleNow.catalogid,
            coursewarename: this.fileName,
            uploadfilename: jsonobj.image
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let params = this.conputeXHRParams(1);
            this.loadList(params);
            this.loading.close();
          } else {
            this.loading.close();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //添加课件
      gotoMake() {
        this.$alert('请前往‘课程列表’-‘课件/备课’处设置', '提示', {
          confirmButtonText: '确定',
        });
      },
      show(item, index) {
        Vue.set(this.lessonWareList[index], 'show', true);
        this.count++;
        this.$forceUpdate();
      },
      addWare() {
        if (this.lessonWareList == null) {
          this.warePopShow = false;
          return;
        }
        let list = [];
        //根据lessonWareList中每个项的show是否为true，将其添加到list中
        for (let i = 0; i < this.lessonWareList.length; i++) {
          if (this.lessonWareList[i].show === true) {
            list.push(this.lessonWareList[i]);
          }
        }
        if (list.length === 0) {
          this.$message({
            message: '请选择相应的课件',
            type: 'waring',
          })
        } else {
          const loading = this.$loading({
            lock: true,
            text: '添加中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          let count = 0;
          for (let i = 0; i < list.length; i++) {
            //接口：添加课件到对应的课程目录
            this.$http({
              url: '/indexapp.php',
              method: 'GET',
              params: {
                c: 'ClassCourseWare',
                a: 'AddClassCourseWare',
                id: this.id,
                rid: this.classScheduleNow.rid,
                lessonid: this.classScheduleNow.lessonid,
                classid: this.classScheduleNow.classid,
                coursewareid: list[i].sceneid,
                classcatalogid: this.classScheduleNow.catalogid,
                coursewarename: list[i].coursewarename,
              }
            }).then((response) => {
              response = response.data;
              if (response.code === 111) {
                this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
              }
              if (response.code === 200 || response.code === 102) {
                count++;
                if (count === list.length) {
                  loading.close();
                  this.$message({
                    message: '添加成功',
                    type: 'success'
                  });
                  this.warePopShow = false;
                  let params = this.conputeXHRParams(1);
                  this.loadList(params);
                  this.$forceUpdate();
                }
              }
            }).catch((err) => {
              this.$alert('请求失败，请重试', '提示', {
                confirmButtonText: '确定',
              });
              loading.close();
            });
          }
        }
      },
      //-------------------回顾直播---------------------------//
      reviewLive(item) {
        let id = this.id;
        let classid = item.classid;
        let rid = item.rid;
        let lessonid = item.lessonid;
        let catalogindex = item.catalog_index;
        let catalogid = item.catalogid;
        window.open(`${this.GLOBAL.liveUrl}/review.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
      },
      //-------------------进入直播间---------------------------//
      gotoLive(item) {
        if (this.isSameDay(this.returnServerToday, item.planstarttime.substring(0, 10))) {
          let id = this.id;
          let classid = item.classid;
          let rid = item.rid;
          let lessonid = item.lessonid;
          let catalogindex = item.catalog_index;
          let catalogid = item.catalogid;
          window.open(`${this.GLOBAL.liveUrl}/live.html?sessionid=${id}&classid=${classid}&rid=${rid}&lessonid=${lessonid}&catalogid=${catalogid}&catalogindex=${catalogindex}`)
        } else {
          this.changetimeShow = true;
        }
      },
      goChangeTime() {
        this.$router.push('/console/calendar/schooltime');
      },
      //编辑课件
      editWare(item) {
        window.open(`${this.GLOBAL.editUrl}indexapp.php#/scene/create/${item.coursewareid}?pageId=1&sid=${this.id}`)
      },
      //预览课件和分享课件(预览和分享是同一个功能)
      previewWare(item) {
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
      //删除课件
      delWare(item, index, index2) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassCourseWare',
            a: 'DeleteClassCourseWare',
            id: this.id,
            rid: item.rid,
            lessonid: item.lessonid,
            classid: item.classid,
            coursewareid: item.coursewareid,
            classcatalogid: item.classcatalogid,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            let tempList = this.list[index].coursewarelist;
            tempList.splice(index2, 1);
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.$forceUpdate()
          }
        }).catch((err) => {

        });
      },
    },
    computed: {
      computeChoseDay() {
        let month = this.time.getMonth() + 1;
        let day = this.time.getDate();
        let weeks = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        let weekday = weeks[this.time.getDay()];
        return `${month}月${day}日 ${weekday}`
      },
    },
    created() {
      let params = this.conputeXHRParams(1);
      this.loadList(params);
    },
    components: {
      calendar,
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .timetable
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .list-wrapper
        margin-top: 10px
        .list-title
          height: 68px
          line-height: 68px
          padding-left: 41px
          font-size: 20px;
          color: #333333
          font-weight: bold
          background: #fff url('./deco-title.png') no-repeat left 20px center / 6px 25px
        .list-item
          margin-top: 10px
          background: #fff
          &::first-child
            margin-top: 0
          .item-top
            height: 132px
            position: relative
            .time-wrapper
              float: left
              margin: 41px 22px 0 20px
              .starttime
                font-size: 20px;
                color: #333333
                font-weight: bold
                height: 28px;
              .endtime
                font-size: 16px;
                color: #666666
                font-weight: bold
                height: 22px
            .item-img-wrapper
              float: left
              margin-top: 20px
              margin-right: 15px
              position: relative
              .item-img-icon {
                position: absolute
                left: 0
                top: 0
                display: inline-block
                width: 64px
                height: 26px
                line-height: 26px
                text-align: center
                font-size: 14px
                color: #ffffff
                background: rgba(0, 0, 0, 0.5)
              }
            .class-content-wrapper
              float: left
              .main-title
                padding-top: 39px
                height: 25px
                line-height: 25px
                font-size: 18px
                color: #333
                .connect {
                  display: inline-block
                  margin-left: 10px
                  height: 24px
                  line-height: 24px
                  text-align: center
                  width: 74px
                  border: 1px solid #3399ff
                  font-size: 14px
                  color: #3399ff
                  box-sizing: border-box
                  border-radius: 12px
                  cursor: pointer
                }
              .sub-title {
                margin-top: 10px
                height: 20px
                line-height: 20px
                font-size: 14px
                color: #888
              }
            .finish-icon {
              position: absolute
              display: inline-block
              right: 20px
              top: 36px
              width: 78px
              height: 60px
              background: url('./finish.png') no-repeat center / 78px 60px

            }
          .item-bottom
            .mulu-item
              border-top:1px solid #e9e9e9
              height: 72px
              .time-wrapper
                display: inline-block
                width: 270px
                height: 72px
                line-height: 72px
                position: relative
                cursor: pointer
                .mulu-name
                  margin-left: 40px
                  font-size: 16px
                  color: #333
              .mulu-operate-wrapper
                float: right
                margin: 20px 15px 0 0
                height: 32px
                .mulu-btn
                  display: inline-block
                  width: 100px
                  height: 32px
                  line-height: 32px
                  font-size: 16px
                  color: #fff
                  margin-right: 20px
                  border-radius: 4px
                  box-sizing: border-box
                  &:last-child
                    margin-right: 15px
                .check, .add {
                  border: 1px solid #e9e9e9
                  color: #333
                }
                .check {
                  text-align: left
                  text-indent: 12px
                  &.show {
                    background: url('./up.png') no-repeat right 6px center / 14px 14px
                  }
                  &.not-show {
                    background: url('./down.png') no-repeat right 6px center / 14px 14px
                  }
                }
                .review {
                  background: #d9a60d
                }
                .live {
                  background: #3399ff
                }
            .wareList-wrapper
              padding: 20px 30px
              background: #e4e4e4
              .ware-item
                height: 60px
                background: #ffffff
                border-radius: 4px
                margin-bottom: 10px
                &:last-child
                  margin: 0
                .ware-img-wrapper
                  float: left
                  width: 60px
                  height: 40px
                  margin: 10px 0 0 15px
                .courseware-name
                  margin-left: 10px
                  float: left
                  line-height: 60px
                  font-size: 14px
                  color: #000
                .courseware-btn-wrapper
                  float: right
                  height: 28px
                  margin: 16px 15px 0 0
                  .courseware-btn
                    height: 28px
                    width: 60px
                    font-size: 14px
                    box-sizing: border-box
                    text-align: center
                    border-radius: 4px
                    &.transparent
                      margin-right: 10px
                      line-height: 26px
                      color: #666666
                      border: 1px solid #d7d7d7
                      background: #fafafa
                    &.del
                      line-height: 28px
                      background #ff6666
                      color: #fff
        .no-result {
          padding-top: 50px
          height: 348px
          text-align: center
          box-sizing border-box
          font-size: 0
          background: #fff
          .noresult-link {
            display: block
            margin-top: 10px
            font-size: 18px
            color: #a5a5a5
          }
        }
    .enrollpop-wrapper
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .enrollpop
        margin: auto
        width: 820px
        padding: 30px 60px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .title
          margin-bottom: 15px
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .sub-title
          margin-bottom: 10px
          font-size: 14px
          color: #000000
          height: 20px
          line-height: 20px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .table
          width: 700px
          background: #ffffff
          text-align: center
          font-size: 0
          table-layout: fixed
          border: 1px solid #e4e4e4
          .tr-title
            .th
              height: 40px
              line-height: 40px
              width: 175px
              font-size: 14px
              color: #fff
              background: rgba(0, 0, 0, 0.8)
              box-sizing: border-box
              border-right: 1px solid #fff
              &:last-child
                border: none
          .tr-content
            border-bottom: 1px solid #e4e4e4
            &:last-child
              border: none
            .td
              height: 40px
              line-height: 40px
              width: 233px
              font-size: 14px
              color: #000
              border-right: 1px solid #e4e4e4
              &:last-child
                border: none
    .warePop
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      z-index 300
      .ware-content-wrapper
        margin: auto
        width: 720px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .ware-title
          font-size: 24px
          color: #000000
          font-weight: bold
          line-height: 40px
        .flex-wrapper
          margin: 25px 0 8px 0
          display: flex
          justify-content space-between
          .left
            font-size: 14px
            color: #000000
            line-height: 19px
          .right
            font-size: 14px
            color: #3399ff
            line-height: 19px
            cursor: pointer
        .ware-wrapper
          width: 600px
          height: 450px
          padding: 20px
          border: 1px solid #e4e4e4
          box-sizing border-box
          overflow auto
          .classware
            padding: 10px 0
            border-bottom: 1px solid #e4e4e4
            .cover
              vertical-align top
            .classware-middle
              display: inline-block
              margin-left: 10px
              vertical-align top
              .title
                font-size: 14px
                color: #000000
                line-height: 22px
              .introduce
                margin-top: 12px
                width: 400px
                height: 26px
                font-size: 12px
                color: #999999
                line-height: 13px
                overflow hidden
            .del
              position relative
              top: 20px
              margin-left: 20px
              cursor pointer

        .ware-btn-outside
          margin-top: 40px
          height: 34px
          .ware-btn-inside
            margin: 0 auto
            width: 225px
            .cancel, .confirm
              width: 80px
              height: 34px
              line-height: 34px
              text-align: center
              font-size: 16px
              color: #ffffff
              border-radius 4px
              box-sizing border-box
            .cancel
              margin-right: 65px
              background #ccc
            .confirm
              background #3399ff

    .newpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .newpop
        margin: auto
        padding: 30px 60px 30px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .new-title
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .block
          margin-top: 20px
          padding: 0 35px
          height: 80px
          line-height: 80px
          border-radius: 4px
          cursor: pointer
          .img
            position relative
            top: 10px
          .text
            display inline-block
            width: 150px
            height: 80px
            line-height: 80px
            text-align: center
            font-size: 16px
            color: #ffffff
        .btn1
          margin-top: 40px
          background #3399ff
        .btn2
          background: #33cc33
          position relative
          .input-file
            position: absolute
            left: 0
            top: 0
            right: 0
            bottom: 0
            width: 100%;
            height: 100%;
            padding: 0
            margin: 0
            opacity: 0
            cursor: pointer
        .newpop-hint{
          margin-top:16px;
          line-height:14px;
          font-size:12px;
          color:#666;
          width: 250px;
        }
    .chantime-mask {
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      overflow: auto
      .chantime {
        margin: auto
        height: 416px
        width: 460px
        padding: 30px 36px 45px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .img-wrapper {
          margin-bottom: 25px
          text-align: center
        }
        .chantime-title {
          text-align: center
          font-size: 20px
          color: #333333
          font-weight: bold
          height: 28px
          line-height: 28px
        }
        .changetime-para {
          margin: 15px 0 35px
          font-size: 16px
          color: #666666
          line-height: 24px
        }
        .changetime-btn {
          display: inline-block
          width: 180px
          height: 40px
          line-height: 40px
          font-size: 16px
          border-radius: 4px
          &.confirm {
            color: #ffffff
            background: #3399ff
            margin-right: 28px
          }
          &.cancel {
            background: #e4e4e4
            color: #333
          }
        }

      }
    }
</style>



// WEBPACK FOOTER //
// src/page/calendarlist/timetable/timetable.vue